import { DepartmentOption } from "@common/components/SelectDepartment";
import { StipendCategory, StipendRuleFrequency } from "@common/utils/graphql";
import { atom, useSetRecoilState } from "recoil";

export type CreateOrEditStipend = {
  name: string;
  terms: string;
  longDetails: string;
  departments: DepartmentOption[];
  frequency?: StipendRuleFrequency;
  isBalanceForwardable: boolean;
  amount?: number;
  startsAt?: Date;
  expiresAt?: Date;
  id?: number;
  category?: StipendCategory;
};

const defaultState = {
  name: "",
  terms: "",
  longDetails: "",
  departments: [],
  frequency: undefined,
  isBalanceForwardable: false,
  amount: undefined,
  startsAt: undefined,
  expiresAt: undefined,
  id: undefined,
  category: undefined,
};

export const createOrEditStipendState = atom<CreateOrEditStipend>({
  key: "createOrEditStipendState",
  default: defaultState,
});

export const useSetInitialCreateOrEditStipendState = () => {
  const setCreateOrEditStipendState = useSetRecoilState(
    createOrEditStipendState,
  );
  return (initialState: Partial<CreateOrEditStipend>) =>
    setCreateOrEditStipendState({
      ...defaultState,
      ...initialState,
    });
};
